import { render, staticRenderFns } from "./partnerRegister.vue?vue&type=template&id=ffbf4f02&scoped=true"
import script from "./partnerRegister.vue?vue&type=script&lang=js"
export * from "./partnerRegister.vue?vue&type=script&lang=js"
import style0 from "./partnerRegister.vue?vue&type=style&index=0&id=ffbf4f02&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffbf4f02",
  null
  
)

export default component.exports